export default {
  primaryBorderRadius: 5,
  secondaryBorderRadius: 12,
  loginLogoMaxWidth: '100%'
}



// WEBPACK FOOTER //
// ./src/theme/dimensions/index.js